/**
 * Route for `igaming-approval-workflows-for-payouts`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingApprovalWorkflowsForPayoutsPage } from "../features/igaming-approval-workflows-for-payouts/IgamingApprovalWorkflowsForPayoutsPage";

export const igamingApprovalWorkflowsForPayoutsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-approval-workflows-for-payouts",
	component: IgamingApprovalWorkflowsForPayoutsPage,
});

export default igamingApprovalWorkflowsForPayoutsRoute;
